import { AppCardBoxLoader, AppNotFoundBox } from "../../../../Libraries";
import { getBrandById } from "../../../../../api";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CreateBrand } from "..";

const EditBrand = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({});

    useEffect(() => {
        if (id) getBrand();
        else setLoading(false);
    }, [id]);

    const getBrand = async () => {
        try {
            const { data } = await getBrandById(id);
            setItem(data.brand);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    };

    return loading ?
        <AppCardBoxLoader />
        : item?._id ?
            <CreateBrand from="edit" item={item} />
            :
            <AppNotFoundBox title='failed_to_load_brand' />
};

export default EditBrand;